/** Year switch + month tabs. Used by all four views via the parent layout. */
import { useRef, useEffect } from "preact/hooks";
import { currentYear, currentMonth } from "../state/store";
import type { JSX } from "preact";
import { MONTHS, YEAR_RANGE } from "../config";

export function MonthBar(): JSX.Element {
  const tabsRef = useRef<HTMLDivElement | null>(null);
  // Read into a local so it's a valid effect dependency (a bare
  // `signal.value` isn't, per react-hooks/exhaustive-deps).
  const month = currentMonth.value;

  // On mobile the month tabs are a single horizontal scroll strip (see the
  // CSS). Keep the selected month scrolled into view. Guarded to the
  // scroll-strip case (scrollWidth > clientWidth) so it's a no-op on the
  // wrapping desktop layout, and block:'nearest' so it never scrolls the page.
  useEffect(() => {
    const tabs = tabsRef.current;
    if (!tabs || tabs.scrollWidth <= tabs.clientWidth) return;
    tabs.querySelector("button.active")?.scrollIntoView({ block: "nearest", inline: "center" });
  }, [month]);

  return (
    <div class="month-bar">
      <div class="year-switch">
        {YEAR_RANGE.map((y) => (
          <button key={y}
            class={y === currentYear.value ? "active" : ""}
            onClick={() => (currentYear.value = y)}
          >
            {y}
          </button>
        ))}
      </div>
      <div class="month-tabs" ref={tabsRef}>
        {MONTHS.map((m, i) => (
          <button key={`m-${i}`}
            class={i === currentMonth.value ? "active" : ""}
            onClick={() => (currentMonth.value = i)}
          >
            {m}
          </button>
        ))}
      </div>
    </div>
  );
}
